import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

export const StyledEmptyState = styled(EmptyState)`
    padding: 44px 12px;
    text-align: center;
    height: auto;
`;
